// Accessible 1–5 maturity-ladder + N/A score selector. Native radios in a
// fieldset give arrow-key navigation and a single tab stop for free. Each chip
// shows the level number and its name (Absent…Optimizing); the full criteria
// for every level live in the ScaleLegend shown alongside the questions.

import { MATURITY_LADDER, type ScoreValue } from '@dwa/shared';

type Option = { value: ScoreValue; label: string; name: string };

const OPTIONS: Option[] = [
  ...MATURITY_LADDER.map((l) => ({ value: l.value, label: String(l.value), name: l.name })),
  { value: 'NA', label: 'N/A', name: 'Not applicable' },
];

export function ScoreScale({
  name,
  value,
  onChange,
}: {
  name: string;
  value: ScoreValue | undefined;
  onChange: (value: ScoreValue) => void;
}) {
  return (
    <fieldset className="flex flex-wrap gap-2">
      <legend className="sr-only">Score (1 = Absent … 5 = Optimizing)</legend>
      {OPTIONS.map((opt) => {
        const id = `${name}-${String(opt.value)}`;
        const selected = value === opt.value;
        return (
          <label
            key={id}
            htmlFor={id}
            title={opt.name}
            className={`flex min-w-[4.25rem] cursor-pointer flex-col items-center rounded-lg border px-3 py-1.5 text-sm font-medium transition ${
              selected
                ? 'border-climb-coral bg-climb-coral text-white'
                : 'border-climb-line-dark bg-climb-surface-2 text-climb-paper hover:border-climb-cyan'
            }`}
          >
            <input
              type="radio"
              id={id}
              name={name}
              className="sr-only"
              checked={selected}
              onChange={() => onChange(opt.value)}
            />
            <span className="font-mono leading-none">{opt.label}</span>
            <span className={`mt-1 text-[11px] leading-tight ${selected ? 'text-white/90' : 'text-climb-teal-soft'}`}>
              {opt.name}
            </span>
          </label>
        );
      })}
    </fieldset>
  );
}
